RivalIQ.apps.Favorites.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    // This max length ensures that ppt titles will fit on one line
    const MAX_TITLE_LENGTH = 45;

    const WidthControl = Marionette.ItemView.mixin({
        ui: {
            widths: '[data-column-width]'
        },
        dashboardModelEvents: {
            'changed:metrics': 'render'
        },
        eventsNotToDebounce: {
            'change @ui.widths': 'onWidthChange'
        },
        behaviors: {
            Localizable: {},
            AttributeBuilder: {}
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        template: '#favoritesBuilderWidthControlTemplate',
        templateHelpers: function () {
            const me = this;
            const focusWidget = me.dashboardModel.getWidget();
            return {
                columnWidths: [
                    {
                        name: 'Half',
                        disabled: !focusWidget.isPropValueValid('columnWidth', 6),
                        value: 6
                    },
                    {
                        name: 'Full',
                        disabled: !focusWidget.isPropValueValid('columnWidth', 12),
                        value: 12
                    }
                ]
            };
        },
        onRender: function () {
            const me = this;
            me.$('[data-toggle="popover"]').popover({
                html: true,
                trigger: 'hover',
                placement: 'auto',
                container: 'body'
            });
        },
        serializeData: function () {
            const me = this;
            const focusWidget = me.dashboardModel.getWidget();
            return _.defaults(focusWidget.getProps(), {
                columnWidth: 12
            });
        },
        onWidthChange: function (e) {
            const me = this;

            let width = parseInt($(e.currentTarget).data('column-width'));
            if (isNaN(width)) {
                width = undefined;
            }

            me.trigger('update:widget', {
                columnWidth: width
            });
        },

        initialize: function () {
            const me = this;

            // Some widgets disallow half-width for different primaryDimensions (e.g., tables with companySet)
            Marionette.bindEntityEvents(me, me.dashboardModel.getWidget(), {
                'change:primaryDimension': 'render'
            });
        }
    });

    views.Builder = Marionette.LayoutView.mixin({
        tagName: 'form',
        className: 'panel-body',
        template: '#favoritesBuilderTemplate',

        regions: {
            subform: '.x-form',
            width: '.width-control'
        },

        ui: {
            title: 'input[name=title]',
            focusCompanyTitlePlacement: '[name=focusCompanyTitlePlacement]',
            interval: 'select[name=groupedBy]',
            displayBenchmark: 'select[name=displayBenchmark]',
            displayBenchmarkInfoBubble: '.x-benchmark-info',
            summaryRow: 'select[name=summaryRow]',
            titleFormGroup: '.x-title',
            refresh: '.reset-title',
            focusCompanyTitlePlacementContainer: '.focus-company-title-placement-container',
            titlePrefix: '.x-title-prefix',
            titleSuffix: '.x-title-suffix'
        },

        events: {
            'click @ui.refresh': 'onRefreshClick'
        },

        eventsNotToDebounce: {
            'input @ui.title': 'onTitleChange',
            'change @ui.focusCompanyTitlePlacement': 'onFocusCompanyPlacementChange'
        },

        dashboardModelEvents: {
            'change:metrics': 'onMetricsChanged'
        },

        collectionEvents: {
            'reset': 'render'
        },

        behaviors: {
            Localizable: {},
            AttributeBuilder: {}
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        onMetricsChanged: function () {
            const me = this;

            // This is to get around an event ordering issue; this builder view and the widget below this builder view are both listening for
            // the metrics changed events. Sometimes though, this builder calls to the widget to get the title. So when the builder gets the
            // change event before the widget, the widget might give the wrong answer for the current title.
            // Instead, we setup a listener to get an event from with widget. That way we have another hook to update the title.
            me._updateWidgetPropChangeListener();
            me.updateTitle();
            me._resetBenchmarkSelectors();
        },

        _updateWidgetPropChangeListener: function () {
            const me = this;

            const currentWidget = me.dashboardModel.getWidget();

            if (me._lastWidget !== currentWidget) {

                if (me._lastWidget) {
                    me.stopListening(me._lastWidget);
                }

                if (currentWidget) {
                    me.listenTo(currentWidget, 'change', function () {
                        me.updateTitle();
                        me.intervalSelector.resetSelector();
                        me._resetBenchmarkSelectors();
                    });
                }

                me._lastWidget = currentWidget;
            }
        },

        _resetBenchmarkSelectors: function () {
            const me = this;

            me.benchmarkSelector.resetSelector();
            me.resetBenchmarkInfoBubble();
        },

        onRender: function () {
            const me = this;

            const Builder = me.getBuilderView();
            me.subform.show(new Builder({
                collection: me.collection,
                dashboardModel: me.dashboardModel
            }));

            me.intervalSelector = new App.views.selectors.Interval({
                el: me.ui.interval,
                dashboardModel: me.dashboardModel
            });
            me.intervalSelector.render();

            me.benchmarkSelector = new App.views.selectors.Benchmark({
                el: me.ui.displayBenchmark,
                dashboardModel: me.dashboardModel
            });
            me.benchmarkSelector.render();
            me.resetBenchmarkInfoBubble();

            me._resetBenchmarkSelectors();
            me._updateWidgetPropChangeListener();

            const widthControl = new WidthControl({
                dashboardModel: me.dashboardModel
            });
            me.listenTo(widthControl, 'update:widget', me.updateWidget);
            me.width.show(widthControl);

            me.updateTitlePlacement();
        },

        resetBenchmarkInfoBubble: function () {
            const me = this;

            const focusWidget = me.dashboardModel.getWidget();
            const widgetSupportsBenchmarkLine = _.result(focusWidget, 'widgetSupportsBenchmarkLine');
            const metricSupportsBenchmarkLine = _.result(focusWidget, 'metricSupportsBenchmarkLine');
            if (widgetSupportsBenchmarkLine && !metricSupportsBenchmarkLine) {
                me.ui.displayBenchmarkInfoBubble.attr('data-content', RivalIQ.strings.favorites_builder_show_benchmark_line_private_metric_description);
            } else {
                me.ui.displayBenchmarkInfoBubble.attr('data-content', RivalIQ.strings.favorites_builder_show_benchmark_line_description);
            }
        },

        getBuilderView: function () {
            const me = this;
            const widgetGroupId = me.getProp('widgetGroupId');

            switch (widgetGroupId) {
                case RivalIQ.enums.widgetGroupType.INSTAGRAM_INSIGHTS_POSTS:
                case RivalIQ.enums.widgetGroupType.INSTAGRAM_INSIGHTS_STORIES:
                case RivalIQ.enums.widgetGroupType.INSTAGRAM_INSIGHTS_STORYDAYS:
                case RivalIQ.enums.widgetGroupType.LIST:
                    return views.forms.List;
                case RivalIQ.enums.widgetGroupType.CHART:
                    return views.forms.Chart;
                case RivalIQ.enums.widgetGroupType.COMPOSITE:
                    return views.forms.Composite;
                default:
                    throw new Error(`unknown widget group type ${widgetGroupId}`);
            }
        },

        onAttach: function () {
            const me = this;
            me.initializePopovers();
            me.updateInputRefresh();

            me._updateWidgetPropChangeListener();
        },

        onDomRefresh: function () {
            const me = this;
            me.initializePopovers();
            me.updateInputRefresh();
            me.updateTitle();
        },

        serializeData: function () {
            const me = this;
            const focusWidget = me.dashboardModel.getWidget();

            return _.defaults(focusWidget.getProps(), {
                columnWidth: 12,
                title: me.createTitle(),
                maxTitleLength: MAX_TITLE_LENGTH,
                focusCompanyTitlePlacement: RivalIQ.enums.widgetFocusCompanyTitlePlacement.NONE
            });
        },

        initializePopovers: function () {
            const me = this;
            me.$('[data-toggle="popover"]').popover({
                html: true,
                trigger: 'hover',
                placement: 'auto',
                container: 'body'
            });
        },

        initializeSelectors: function () {
            const me = this;
            me.buildChartDropdown();
        },

        updateInputRefresh: function () {
            const me = this;
            const title = me.dashboardModel.getWidget().getProp('title');

            if (_.isUndefined(title)) {
                me.ui.refresh.hide();
                me.ui.titleFormGroup.removeClass('has-feedback');
            } else {
                me.ui.refresh.show();
                me.ui.titleFormGroup.addClass('has-feedback');
            }
        },

        onRefreshClick: function () {
            const me = this;

            me.updateWidget({
                title: undefined,
                focusCompanyTitlePlacement: undefined
            });

            me.updateInputRefresh();
            me.updateTitle();
        },

        onFocusCompanyPlacementChange: function (e) {
            const me = this;

            const focusCompanyTitlePlacement = e.currentTarget.value;
            me.updateWidget({
                focusCompanyTitlePlacement: focusCompanyTitlePlacement
            });
            me.updateTitle();
        },

        onTitleChange: function () {
            const me = this;
            me.updateWidget({
                title: me.ui.title.val()
            });
            me.updateInputRefresh();
        },

        updateTitle: function () {
            const me = this;

            let title = me.dashboardModel.getWidget().getProp('title');
            if (_.isUndefined(title)) {
                title = me.createTitle();
                me.ui.title.val(title);
            }

            me.updateTitlePlacement();
        },

        updateTitlePlacement: function () {
            const me = this;

            const focusWidget = me.dashboardModel.getWidget();
            const focusCompanyTitlePlacement = focusWidget.getProp('focusCompanyTitlePlacement') || RivalIQ.enums.widgetFocusCompanyTitlePlacement.NONE;
            const companyName = RivalIQ.state.landscape.getCompanyById(me.getProp('focusCompanyId')).get('name');
            switch (focusCompanyTitlePlacement) {
                case RivalIQ.enums.widgetFocusCompanyTitlePlacement.PREFIX:
                    me.ui.title.removeClass('no-prefix');
                    me.ui.title.addClass('no-suffix');
                    me.ui.titlePrefix.removeClass('display-none').text(companyName);
                    me.ui.titleSuffix.addClass('display-none');
                    break;

                case RivalIQ.enums.widgetFocusCompanyTitlePlacement.SUFFIX:
                    me.ui.title.addClass('no-prefix');
                    me.ui.title.removeClass('no-suffix');
                    me.ui.titlePrefix.addClass('display-none');
                    me.ui.titleSuffix.removeClass('display-none').text(companyName);
                    break;

                case RivalIQ.enums.widgetFocusCompanyTitlePlacement.NONE:
                    me.ui.title.addClass('no-prefix no-suffix');
                    me.ui.titlePrefix.addClass('display-none');
                    me.ui.titleSuffix.addClass('display-none');
                    break;
                default:
                    throw new Error(`unknown title placement - widgetFocusCompanyTitlePlacement ${focusCompanyTitlePlacement}`);
            }

            me.ui.focusCompanyTitlePlacementContainer.find(`[value=${focusCompanyTitlePlacement}]`).prop('checked', 'checked');
            me.ui.focusCompanyTitlePlacementContainer.find('[name=focusCompanyTitlePlacement]').attr('disabled', !focusWidget.widgetSupportsTitlePlacement);
        },

        createTitle: function () {
            const me = this;
            return me.dashboardModel.getWidget().getTitle(null, {
                omitFocusCompanyTitle: true
            });
        },

        updateWidget: function (props) {
            const me = this;

            me.dashboardModel.getWidget().setProps(props, {
                navigate: false
            });
        }
    });
});
